// extracted by mini-css-extract-plugin
export default {"wrap":"tq-z","fullWidth":"uq-z","items":"vq-z","featureCss":"wq-z","disabled":"xq-z","imgCss":"yq-z"};